import { Divider } from "antd"
import UMCButton from "../common/UMCButton"
import UMCAttrComponentView from "./UMCAttrComponentView"
import UMCReplaceComponent from "./UMCReplaceComponent"
import { getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"


const UMCContentSplitLayout = (props) => {

    const dict = useSelector((state) => state.common.dict)

    const parseDomain = (attributes) => {
        return attributes?.length ? attributes.map((attribute, index) => attribute.widget === "REPLACEFIELD" ? (
      <UMCReplaceComponent
            attributes={[attribute]}
      />
    ) : (
      <UMCAttrComponentView
        key={index}
        attribute={{ ...attribute, ...props.otherAttrs }}
      />
    )) : <></>
    }

    return <div className="split-layout">
        <div className="sl-content">
            <div className="sl-domain">
                {(props.heading_1 || (props.subdomain?.length && props.subdomain[0]?.label)) && <Divider orientation="left" orientationMargin="0" plain>{getTranslated(dict, props.heading_1 || props.subdomain[0].label)}</Divider>}
                {props.domain_1 || (props.subdomain?.length && parseDomain(props.subdomain[0]?.attribute))}
            </div>
            <div className="sl-domain">
                {(props.heading_2 || (props.subdomain?.length && props.subdomain[1]?.label)) && <Divider orientation="left" orientationMargin="0" plain>{getTranslated(dict, props.heading_2 || props.subdomain[1].label)}</Divider>}
                {props.domain_2 || (props.subdomain?.length && parseDomain(props.subdomain[1]?.attribute))}
            </div>
        </div>
        {props.footer !== null && <div className="sl-footer">
            <UMCButton
                label={props.backBtnLabel || "LABEL_BACK"}
                disabled={props.disablBackBtn || false}
                onClick={() => props.goBackHandler && props.goBackHandler(true)}
            />
            <UMCButton
                label={props.okBtnLabel || "LABEL_CREATE"}
                disabled={props.disablOKBtn || false}
                onClick={() => props.handleOK && props.handleOK()}
                type="primary"
            />
        </div>}
    </div>
}

export default UMCContentSplitLayout